import * as _ from "lodash";

export class Limit {
    public canvasslimit: number;
    public customfields: number;
    public extracustomfields: number;
    public totalCustomFieldsLimit: number;
    public extrasuperusers: number;
    public totalSuperUsersLimit: number;
    public extrausers: number;
    public superusers: number;
    public users: number;
    public totalUsersLimit: number;
    public houseoccupants: number;
    public customfieldscampaign?: number;

    constructor(data: any) {
        this.setData(data);
    }

    setData(data: object): void {
        _.merge(this, data);
        this.totalCustomFieldsLimit =
            (this.customfields ?? 0) + (this.extracustomfields ?? 0);

        this.totalSuperUsersLimit =
            (this.superusers ?? 0) + (this.extrasuperusers ?? 0);

        this.totalUsersLimit = (this.users ?? 0) + (this.extrausers ?? 0);
    }
}
